import React, { useContext } from 'react'
import Layout from '../../components/layout/layout'
import { useNavigate } from 'react-router-dom'
import Seo from '../../components/Seo/Seo'
import { LanguageContext } from '../../components/LanguageSwitcher/LanguageContext'
import AbstractVisual from '../../components/AbstractVisual/AbstractVisual'
import './notFound.scss'

const NotFound = () => {
  const navigate = useNavigate()
  const { translations } = useContext(LanguageContext)

  return (
    <Layout>
      <Seo title='Page Not Found' description='The page you are looking for does not exist.' noindex />
      <div className='not-found-container'>
        <AbstractVisual className='not-found-visual' shape='ring' colors={['#312e81', '#e7ff02', '#8b5cf6']} />
        <p className='not-found-code'>404</p>
        <h1 className='not-found-title'>{translations.nfTitle}</h1>
        <p className='not-found-txt'>{translations.nfText}</p>
        <button className='not-found-btn' onClick={() => navigate('/')}>{translations.nfBack}</button>
      </div>
    </Layout>
  )
}

export default NotFound
